import { SourcePlatformType } from "@analytics/generated/graphql";

enum Trigger {
  ADD_TO_CART,
  BUY_NOW,
}

export enum Events {
  PRODUCT_VIEW = "product_view",
  ADD_TO_CART = "add_to_cart",
  REMOVE_ITEM_FROM_CART = "remove_from_cart",
  CART = "cart",
  USER = "user",
  WISHLIST = "wishlist",
}

type CommonOptions = {
  source_id?: string;
  source_type?: number | null;
  source_position?: number | null;
  source_platform?: SourcePlatformType;
  offer_id?: string;
  event_id?: number | null;
  position?: number;
};

export type ProductViewContext = {
  context: Events.PRODUCT_VIEW;
  options: Pick<
    CommonOptions,
    "offer_id" | "source_id" | "source_position" | "source_type"
  >;
};

export type AddToCartContext = {
  context: Events.ADD_TO_CART;
  options: CommonOptions & {
    customer_id?: string;
    trigger?: Trigger;
    success?: boolean;
    srtrev?: string;
  };
};

export type RemoveItemFromCartContext = {
  context: Events.REMOVE_ITEM_FROM_CART;
  options: CommonOptions & {
    customer_id?: string;
    shipping?: number;
  };
};

export type CartContext = {
  context: Events.CART;
};

export type UserContext = {
  context: Events.USER;
};

export type AddToWishlistContext = {
  context: Events.WISHLIST;
  options: {
    page_type?: string;
    product_id?: string;
  };
};
